import { NavLink, Outlet } from "react-router";
import { useAuth } from "../auth";
import { NotificationBell } from "./NotificationBell";

export function Layout() {
  const { user, logout } = useAuth();
  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="brand">CARRI</div>
        <div className="section">Логистика</div>
        <NavLink to="/" end>Заявки</NavLink>
        <NavLink to="/lots/new">Новая заявка</NavLink>
        <NavLink to="/directory">Справочники</NavLink>
        <NavLink to="/notifications">Уведомления</NavLink>
        <NavLink to="/profile">Профиль</NavLink>
        {user?.role === "admin" && (
          <>
            <div className="section">Администрирование</div>
            <NavLink to="/admin/users">Пользователи</NavLink>
            <NavLink to="/admin/chats">Чаты</NavLink>
            <NavLink to="/admin/settings">Настройки</NavLink>
            <NavLink to="/admin/audit">Журнал</NavLink>
            <NavLink to="/export">Экспорт</NavLink>
          </>
        )}
        <div className="user">
          <div>{user?.fullName}</div>
          <div style={{ opacity: 0.7 }}>{user?.role === "admin" ? "Администратор" : "Логист"}</div>
          <button className="btn" style={{ marginTop: 8, width: "100%" }} onClick={() => void logout()}>
            Выйти
          </button>
        </div>
      </aside>
      <main className="main">
        <div className="topbar">
          <NotificationBell />
        </div>
        <Outlet />
      </main>
    </div>
  );
}
